/**
 * Auth routes owned by this module.
 *
 * `/sso/callback` is where the API's own `/auth/sso/callback` sends the browser
 * back with a one-time ticket or an error code (`server/internal/identity/
 * sso_service.go`'s `ssoSuccessRedirect` / `ssoErrorRedirect` — the path is
 * fixed there, so it is fixed here). Public and bare, like `/login`: whoever
 * arrives here has no session yet, and the guard must let them through to
 * finish getting one.
 *
 * The other auth screens (`/login`, password reset, invitation) are still
 * declared in `router/index.ts`; this table is spread there beside them.
 */

import type { RouteRecordRaw } from 'vue-router'

export const AUTH_SSO_ROUTES: RouteRecordRaw[] = [
  {
    path: '/sso/callback',
    name: 'sso-callback',
    component: () => import('@/modules/auth/SsoCallbackView.vue'),
    meta: { public: true, bare: true, titleKey: 'routes.titles.ssoCallback' },
  },
]
